WarningBannerView = require 'views/header/warning-banner-view'
templates = require 'views/internal/templates'

module.exports = class TwoFactorBackupsBannerView extends WarningBannerView

  render: ->
    @$el.html(templates.fill('header_two_factor_backups_banner'))
    @



// WEBPACK FOOTER //
// ./app/scripts/views/header/two-factor-backups-banner-view.coffee